import { getErrorMessage } from "../../../utils/utils"
import { Api } from "../ApiConfig"
import { ApiException } from "../ApiException"
import { ICustomField } from "../../../@types/customField.type";

export const getAllResourceCustomField = async () => {

  try {
    const { data } = await Api.get(`/api/ResourceCustomField/GetAllResourceCustomFields`)
    return data

  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Campos'))
  }
}


export const addOrUpdateResourceCustomField = async (resourceCustomField: ICustomField) => {
  try {
  const { data } = await Api.post('/api/ResourceCustomField/AddOrUpdateResourceCustomField', resourceCustomField);
  return data;

  } catch (error) {
    const message = 'Erro ao criar ou atualizar campo do Colaborador';
    throw new ApiException(getErrorMessage(error, message));
  }
}


export const deleteResourceCustomField = async (id: string) => {
  try {
    await Api.delete(`/api/ResourceCustomField/DeleteCustomFieldById/${id}`);
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao deletar o campo'))
  }
}
